import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, switchMap, throwError } from 'rxjs';
import { AuthJwtService } from '../services/auth-jwt.service';
import { UserService } from '../services/user.service';

export const authJwtInterceptor: HttpInterceptorFn = (req, next) => {
  const jwtService = inject(AuthJwtService);
  const userService = inject(UserService);
  const router = inject(Router);

  const token = jwtService.getToken();
  if (token) {
    req = req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        if (error.headers.get('Token-Expired')) {
          return jwtService.refreshTokenShared().pipe(
            switchMap(res => {
              const retried = req.clone({ setHeaders: { Authorization: `Bearer ${res.tokenPCT}` } });
              return next(retried);
            }),
            catchError(refreshError => {
              userService.clearUserData();
              jwtService.logout();
              router.navigate(['/login']);
              return throwError(() => refreshError);
            })
          );
        }
        userService.clearUserData();
        jwtService.logout();
        router.navigate(['/login']);
      }
      return throwError(() => error);
    })
  );
};
